import axios from 'axios';

const TOKEN_KEY = 'shield_token';

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

// AuthContext가 로그아웃 함수를 등록해두면 401 응답 시 자동 호출됨
let logoutHandler = null;
export const registerLogoutHandler = (fn) => {
  logoutHandler = fn;
};

const api = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청마다 JWT 첨부
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    // sliding session — 백엔드가 갱신해준 토큰으로 교체
    const refreshed = response.headers['x-refresh-token'];
    if (refreshed) setToken(refreshed);
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && logoutHandler) logoutHandler();
    return Promise.reject(error);
  }
);

export default api;
